class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.targets = document.querySelectorAll("[data-header-target]");
    this.sticking = false;

    const setHeightVariable = () =>
      document.documentElement.style.setProperty(
        "--header-height",
        `${this.getBoundingClientRect().height}px`,
      );
    window.requestAnimationFrame(setHeightVariable);
    window.addEventListener("resize", setHeightVariable);

    this._moveStickTarget();
    this._initObserver();
    this._initActiveHoverHandlers();
    this._initCustomSelectTrigger();
  }

  _initObserver() {
    const cb = (entries) => {
      entries.forEach((entry) => {
        switch (entry.target.dataset.headerTarget) {
          case "stick":
            this.sticking = !entry.isIntersecting;
            this.classList.toggle("sticking", this.sticking);
            document.body.classList.toggle("header--sticking", this.sticking);
            break;
        }
      });
    };

    const observer = new IntersectionObserver(cb, {});
    this.targets.forEach((target) => observer.observe(target));
  }

  _moveStickTarget() {
    // Moving this element in editor messes things up (sections disappear when you change things)
    // so just skip.
    if (Shopify?.designMode) return;

    // Move stick target before header (but after promo bar, if present)
    // We can't directly place the target there because these are both
    // sections in a section group.
    const target = document.querySelector('[data-header-target="stick"]');
    const header = this.closest(".shopify-section--header");
    header.parentNode.insertBefore(target, header);
  }

  _getTopmostParentLi(li, container) {
    let currentLi = li;
    let parentLi = currentLi.closest("ul")?.closest("li");
    while (parentLi && container.contains(parentLi)) {
      currentLi = parentLi;
      parentLi = currentLi.closest("ul")?.closest("li");
    }
    return currentLi;
  }

  _initActiveHoverHandlers() {
    const nav = this.querySelector(".header__main-nav");

    this.addEventListener("mouseover", (e) => {
      const li = e.target.closest("li");
      if (li && this.contains(li)) {
        li.classList.add("has-active");

        // Ensure topmost parent li gets .has-active
        const topLi = this._getTopmostParentLi(li, nav);
        if (topLi) {
          topLi.classList.add("has-active");
        }

        nav.classList.add("has-hover-active");
      }
    });

    this.addEventListener("mouseout", (e) => {
      const li = e.target.closest("li");
      if (li && this.contains(li)) {
        li.classList.remove("has-active");

        // Remove .has-active from topmost parent li if no active descendants remain
        const topLi = this._getTopmostParentLi(li, nav);
        if (topLi) {
          const stillActive = topLi.querySelector("li.has-active");
          if (!stillActive) {
            topLi.classList.remove("has-active");
          }
        }
      }
      nav.classList.remove("has-hover-active");
    });

    this.addEventListener("click", (e) => {
      const li = e.target.closest("li");
      if (li && this.contains(li)) {
        li.parentElement.querySelectorAll("li.has-active").forEach((sibling) => {
          if (sibling !== li) sibling.classList.remove("has-active");
        });
        li.classList.add("has-active");

        // Ensure topmost parent li gets .has-active
        const topLi = this._getTopmostParentLi(li, nav);
        if (topLi) {
          topLi.classList.add("has-active");
        }

        nav.classList.add("has-hover-active");
      }
    });
  }

  _initCustomSelectTrigger() {
      const displayDiv = this.querySelector("#selected-country-display");
      const select = displayDiv?.nextElementSibling;

      if (!displayDiv || !select) return;

      displayDiv.addEventListener("click", function () {
        if (typeof select.showPicker === "function") {
          select.showPicker();
          return;
        }
        const event = new MouseEvent('mousedown', {
          view: window,
          bubbles: true,
          cancelable: true
        });
        select.dispatchEvent(event);
      });
  }

}

if (!customElements.get("sticky-header")) {
  customElements.define("sticky-header", StickyHeader);
}
